<template>
  <div id="other">
    <top></top>
    <div class="main">
      <div class="content">
        <p class="other_title">其他活动申报</p>
        <div class="other_border"></div>
        <div class="other_form">
          <el-form
            :model="otherForm"
            :rules="otherFormRules"
            ref="otherFormRef"
            label-position="top"
          >
            <el-form-item label="单位名称" prop="company_name">
              <el-input
                placeholder="请输入单位名称"
                v-model="otherForm.company_name"
              ></el-input>
            </el-form-item>
            <el-form-item label="公司地址" prop="company_address">
              <el-input
                placeholder="请输入公司地址"
                v-model="otherForm.company_address"
              ></el-input>
            </el-form-item>
            <el-form-item></el-form-item>
            <el-form-item label="单位简介" prop="company_introduction">
              <el-input
                :rows="6"
                placeholder="请输入单位简介"
                type="textarea"
                v-model="otherForm.company_introduction"
              ></el-input>
            </el-form-item>
            <el-form-item label="营业执照" prop="business_license">
              <div class="other_uploader">
                <singleImageUpload
                  :imageSrc="otherForm.business_license"
                  @handleUploading="handleUploading"
                  @handleUploadSuccess="handleUploadSuccess"
                  @handlePreviewImage="handlePreviewImage"
                  @handleDeleteImage="handleDeleteImage"
                ></singleImageUpload>
              </div>
            </el-form-item>
            <el-form-item label="简介上传" prop="introduction_file">
              <div>
                <singleFileUpload
                  :file="otherForm.introduction_file"
                  @handleUploading="handleUploading"
                  @handleUploadSuccess="handleUploadFileSuccess"
                ></singleFileUpload>
              </div>
            </el-form-item>
            <el-form-item label="项目联系人" prop="project_contact">
              <el-input
                placeholder="请输入项目联系人"
                v-model="otherForm.project_contact"
              ></el-input>
            </el-form-item>
            <el-form-item label="部门及职务" prop="department_position">
              <el-input
                placeholder="请输入部门及职务"
                v-model="otherForm.department_position"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机及微信" prop="mobile">
              <el-input
                placeholder="请输入电话"
                v-model="otherForm.mobile"
              ></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input
                placeholder="请输入邮箱"
                v-model="otherForm.email"
              ></el-input>
            </el-form-item>
            <el-form-item></el-form-item>
            <el-form-item></el-form-item>
            <el-form-item label="合作意向说明" prop="cooperation_intention">
              <el-input
                :rows="6"
                placeholder="请输入合作意向说明"
                type="textarea"
                v-model="otherForm.cooperation_intention"
              ></el-input>
            </el-form-item>
            <el-form-item></el-form-item>
            <el-form-item></el-form-item>
            <el-form-item label="申报活动名称" prop="declaration_activity_name">
              <el-input
                placeholder="请输入申报活动名称"
                v-model="otherForm.declaration_activity_name"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="other_button">
          <div class="declare_borderButton" @click="back">返回</div>
          <div class="declare_fillButton" @click="verifyForm">提交</div>
        </div>
      </div>
    </div>
    <maskLayer
      :show="maskLayerShow"
      :type="maskLayerType"
      :imgSrc="otherForm.business_license"
      @handleCancelPreviewImage="handleCancelPreviewImage"
    ></maskLayer>
  </div>
</template>

<script>
import top from "../../components/top.vue";
import singleImageUpload from "../../components/singleImageUpload.vue";
import maskLayer from "../../components/maskLayer.vue";
import singleFileUpload from "../../components/singleFileUpload.vue";
import {
  saveOtherActivityDeclaration,
  getOtherActivityDeclarationResult,
} from "../../api/api";
export default {
  name: "otherDeclaration",
  components: { top, singleImageUpload, maskLayer, singleFileUpload },
  data() {
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入联系邮箱"));
      }
      const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
      if (!emailPattern.test(value)) {
        callback(new Error("请输入有效的邮箱地址"));
      } else {
        callback();
      }
    };
    return {
      examineResult: "",
      otherForm: {
        company_name: "",
        company_address: "",
        company_introduction: "",
        business_license: "",
        introduction_file: {},
        project_contact: "",
        department_position: "",
        mobile: "",
        email: "",
        cooperation_intention: "",
        declaration_activity_name: "",
      },
      otherFormRules: {
        company_name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入单位名称",
          },
        ],
        company_address: [
          {
            required: true,
            trigger: "blur",
            message: "请输入单位地址",
          },
        ],
        company_introduction: [
          {
            required: true,
            trigger: "blur",
            message: "请输入单位简介",
          },
        ],
        business_license: [
          {
            required: true,
            trigger: "blur",
            message: "请上传营业执照",
          },
        ],
        project_contact: [
          {
            required: true,
            trigger: "blur",
            message: "请输入项目联系人",
          },
        ],
        department_position: [
          {
            required: true,
            trigger: "blur",
            message: "请输入部门及职位",
          },
        ],
        mobile: [
          {
            required: true,
            trigger: "blur",
            message: "请输入手机号或微信",
          },
        ],
        email: [
          {
            required: true,
            trigger: "blur",
            validator: validateEmail,
          },
        ],
        cooperation_intention: [
          {
            required: true,
            trigger: "blur",
            message: "请输入合作意向说明",
          },
        ],
        declaration_activity_name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入申报活动名称",
          },
        ],
      },
      maskLayerShow: false,
      maskLayerType: "",
    };
  },
  created() {
    this.getOtherDeclarationResult();
  },
  methods: {
    async getOtherDeclarationResult() {
      const res = await getOtherActivityDeclarationResult();
      if (res.data !== []) {
        let data = res.data;
        let obj = this.otherForm;
        obj.company_name = data.base_company_cn;
        obj.company_address = data.base_detailed_address;
        obj.company_introduction = data.base_introduce;
        obj.business_license = data.gen_business_license;
        obj.project_contact = data.base_contacts;
        obj.department_position = data.base_position;
        obj.mobile = data.base_mobile;
        obj.email = data.base_email;
        obj.cooperation_intention = data.intent_info;
        obj.declaration_activity_name = data.brand_name_cn;
        obj.introduction_file = {
          uri: data.base_introduce_file,
        };
      }
    },
    verifyForm() {
      this.$refs["otherFormRef"].validate((valid, field) => {
        if (valid) {
          this.submitForm();
        } else {
          let arr = Object.keys(field);
          let tips = field[arr[0]][0].message;
          this.$message.error(tips);
          return false;
        }
      });
    },
    submitForm() {
      let data = this.otherForm;
      let obj = {
        base_company_cn: data.company_name,
        base_detailed_address: data.company_address,
        base_introduce: data.company_introduction,
        gen_business_license: data.business_license,
        base_introduce_file: data.introduction_file.uri,
        base_contacts: data.project_contact,
        base_position: data.department_position,
        base_mobile: data.mobile,
        base_email: data.email,
        intent_info: data.cooperation_intention,
        brand_name_cn: data.declaration_activity_name,
      };
      this.$confirm("确定要提交其他活动申报吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await saveOtherActivityDeclaration(obj);
          if (res.code == 1) {
            this.$message.success("提交成功！");
            this.$router.push({
              path: "/home",
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(() => {});
    },
    handleUploading() {
      this.maskLayerShow = true;
      this.maskLayerType = "upload";
    },
    handleUploadSuccess(src) {
      this.maskLayerShow = false;
      this.maskLayerType = "";
      if (src) {
        this.otherForm.business_license = src;
      }
    },
    handlePreviewImage() {
      this.maskLayerShow = true;
      this.maskLayerType = "preview";
    },
    handleDeleteImage() {
      this.otherForm.business_license = "";
    },
    handleCancelPreviewImage() {
      this.maskLayerShow = false;
      this.maskLayerType = "";
    },
    handleUploadFileSuccess(file) {
      this.maskLayerShow = false;
      this.maskLayerType = "";
      if (file) {
        this.otherForm.introduction_file = file;
      }
    },
    back() {
      this.$router.push({
        path: "/home",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.other_title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}
.other_border {
  width: 100%;
  height: 5px;
  background-color: #f3f3f3;
  margin: 20px 0;
}
/deep/ .el-form {
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    width: 25%;
    margin-right: 2%;
    .other_uploader {
      height: 160px;
    }
  }
  .el-form-item:nth-child(3) {
    margin-right: 0;
  }
}
.other_button {
  display: flex;
  width: 267px;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
  justify-content: space-between;
  align-items: center;
}
</style>